var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToolsWenchScrewdriver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18800_33016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.75122 23.0621C4.3293 23.484 3.75704 23.7211 3.16035 23.7211C2.56366 23.7211 1.99141 23.484 1.56948 23.0621C1.14756 22.6402 0.910522 22.0679 0.910522 21.4712C0.910522 20.8745 1.14756 20.3023 1.56948 19.8804L7.93296 13.5209L11.1147 16.7026L4.75122 23.0621Z",
    stroke: "#8A8A8A",
    strokeWidth: 1.31306,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5368 6.04156L9.52246 15.0558",
    stroke: "#8A8A8A",
    strokeWidth: 1.31306,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7595 5.99353C20.4782 6.27477 20.0966 6.43271 19.6988 6.43262C19.3009 6.43252 18.9194 6.2744 18.6382 5.99303C18.357 5.71165 18.199 5.33009 18.1991 4.93226C18.1992 4.53443 18.3573 4.15294 18.6387 3.8717L21.2905 1.22192L23.4113 3.34175L20.7595 5.99353Z",
    stroke: "#8A8A8A",
    strokeWidth: 1.31306,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3998 8.59332L8.11005 6.29851C8.37659 5.61986 8.43937 4.8782 8.29072 4.1644C8.14206 3.4506 7.78842 2.79566 7.27312 2.27984C6.66987 1.68085 5.87911 1.30736 5.03331 1.22192C5.39233 1.79569 5.54626 2.47422 5.46997 3.14674C5.39368 3.81927 5.09168 4.44607 4.61326 4.92484C4.13483 5.40361 3.50825 5.70607 2.83578 5.78285C2.16331 5.85963 1.48467 5.70619 0.910645 5.34759C0.970348 5.91887 1.16151 6.46858 1.46916 6.95365C1.7768 7.43871 2.19258 7.84596 2.68391 8.14349C3.17525 8.44102 3.72879 8.62076 4.3012 8.66861C4.8736 8.71647 5.44931 8.63115 5.98323 8.41933L7.5591 9.9952",
    stroke: "#8A8A8A",
    strokeWidth: 1.31306,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3894 16.8287L16.1643 18.6026C15.8496 19.4045 15.8206 20.2904 16.0823 21.1111C16.3439 21.9319 16.8802 22.6376 17.6009 23.1095C18.3217 23.5813 19.1829 23.7906 20.0399 23.7022C20.8968 23.6137 21.6971 23.2329 22.3063 22.6237C22.9154 22.0146 23.2962 21.2142 23.3847 20.3573C23.4732 19.5004 23.2639 18.6392 22.792 17.9184C22.3201 17.1977 21.6144 16.6614 20.7937 16.3997C19.9729 16.1381 19.087 16.1671 18.2851 16.4817L15.7743 13.9709",
    stroke: "#8A8A8A",
    strokeWidth: 1.31306,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6524 20.3444C19.4453 20.3444 19.2775 20.1766 19.2775 19.9695C19.2775 19.7624 19.4453 19.5945 19.6524 19.5945",
    stroke: "#8A8A8A",
    strokeWidth: 1.31306
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6523 20.3444C19.8594 20.3444 20.0273 20.1765 20.0273 19.9695C20.0273 19.7624 19.8594 19.5945 19.6523 19.5945",
    stroke: "#8A8A8A",
    strokeWidth: 1.31306
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18800_33016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.160889 0.47168)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolsWenchScrewdriver);
export default __webpack_public_path__ + "static/media/tools-wench-screwdriver.ec0d0453f2d6ada5cee6f304bc9914a6.svg";
export { ForwardRef as ReactComponent };